<template>
    <div id="main_div">
        <!-- Home Section start-->
        <section id="home" class="home">
            <div class="home-decor">
                <div class="home-circle1 small-screen">
                    <img :src="require('../assets/images/main-banner3.png')" alt="" />
                </div>
                <div class="home-circle2 small-screen">
                    <img :src="require('../assets/images/main-banner12.png')" alt="" />
                </div>
                <div class="home-circle3 small-screen">
                    <img :src="require('../assets/images/main-banner1.png')" alt="" />
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-5">
                        <div class="home-contain">
                            <div>
                                <img
                                    :src="require('../assets/images/biglogo.png')"
                                    alt="caption-img"
                                    class="caption-img mb-5"
                                />
                                <p class="grey-text">
                                    <b>
                                        Enhance your AV business by Partnering<br />
                                        with the most innovative AV programming<br />
                                        Brand in the UK, Europe & US.</b
                                    >
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 offset-md-1">
                        <div class="home-right">
                            <!-- Tile js start -->
                            <Tile :image="'mobile.png'" />
                            <!-- Tile js end -->
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--Home Section End -->

        <!-- Services Start  -->
        <Services />
        <!-- Services End -->

        <!-- About Start  -->
        <About />
        <!-- About End -->

        <!-- Feature Section start -->
        <Feature />
        <!-- Feature Section End -->

        <!-- Screenshots Section Start -->
        <Screenshots />
        <!-- Screenshots Section End -->

        <!-- Team Section Start -->
        <Team />

        <!-- team Section End -->

        <!-- blog Section Start -->
        <Latest-blog />
        <!-- blog Section End -->

        <!-- Price Section start-->
        <Price />
        <!-- Price Section End -->

        <!-- testimonial Section start-->
        <Testimonial />
        <!-- testimonial Section End -->

        <!-- Contact Section start -->
        <Snowf
            :amount="200"
            :size="15"
            :speed="1.5"
            :wind="0"
            :opacity="1.2"
            :swing="2"
            :image="null"
            :zIndex="null"
            :resize="true"
            color="#fff"
            v-if="isItXmas"
        />
        <Contact_us />
        <!-- Contact Section End -->

        <!--Subscribe section start-->
        <Subscribe />
        <!--Subscribe section Ends-->

        <!--Map Section Start-->
        <Map />
        <!--Map Section Ends-->

        <!-- Footer Section start -->
        <Footer />
        <!-- Footer Section End -->

        <js />
    </div>
</template>
<script>
import Snowf from "vue-snowf"

export default {
    name: "Home_one",
    components: {
        Snowf
    },
    beforeCreate: function () {
        document.body.className = ""
    },
    computed: {
        isItXmas () {
            const date = new Date()
            const sXmas = new Date("1997-12-01T00:00:00")
            const eXmas = new Date("1997-01-06T00:00:00")

            sXmas.setFullYear(date.getFullYear())
            eXmas.setFullYear(date.getFullYear() + 1)

            return !!(date >= sXmas && date <= eXmas)
        }
    }
}
</script>
<!--remove comment below line to set color -->
<!--<style lang="css">-->
<!--@import '../public/assets/css/color/color-2.css';-->
<!--</style>-->



// WEBPACK FOOTER //
// src/demo_page/home_one.vue